import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { cva } from 'class-variance-authority';
export var buttonCardStyles = /*#__PURE__*/cva(['tw-relative tw-flex tw-flex-col tw-h-28',
// Rounding and overflow
'tw-rounded-2 tw-overflow-hidden',
// Background color
'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-04',
// Transition
'tw-transition-transform tw-will-change-transform'], {
  variants: {
    currentState: {
      "true": 'tw-shadow-02 tw-scale-125 tw-z-2 dark:tw-shadow-none',
      "false": ''
    },
    expandOrientation: /*#__PURE__*/_defineProperty(/*#__PURE__*/_defineProperty(/*#__PURE__*/_defineProperty({}, 'left-to-right', ['tw-origin-left', 'tw-transform tw-translate-x-0.4']), 'right-to-left', ['tw-origin-right', 'tw-transform -tw-translate-x-0.4']), 'center', 'tw-origin-center'),
    mobile: {
      "true": 'tw-min-w-24',
      "false": 'tw-w-full'
    }
  }
});